export default __webpack_public_path__ + "static/media/img_00.6f794ebd.jpg";